import React from 'react';

const Index = () => {
    return (
        <div className={'h-[100vh] w-full bg-[#FFFFFF] justify-center items-center flex'}>
            <img src={require("@assets/OrganoxLogo.png")} alt={"logo"}/>
        </div>
    );
};

export default Index;
